(function () {
  var PROXY_URL = 'https://honza-clickup-proxy.honza-api.workers.dev';

  document.querySelectorAll('[data-clickup-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var msgEl = form.querySelector('.trade-form-msg');
      var origLabel = btn.textContent;

      btn.disabled = true;
      btn.textContent = 'Sending\u2026';
      if (msgEl) msgEl.textContent = '';

      var payload = {
        list: form.getAttribute('data-clickup-form'),
        name: (form.querySelector('[name="contact[name]"]') || {}).value || '',
        email: (form.querySelector('[name="contact[email]"]') || {}).value || '',
        company: (form.querySelector('[name="contact[company]"]') || {}).value || '',
        phone: (form.querySelector('[name="contact[phone]"]') || {}).value || '',
        message: (form.querySelector('[name="contact[body]"]') || {}).value || '',
      };

      fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function () {})
        .catch(function () {})
        .finally(function () {
          form.submit();
        });
    });
  });
})();
